import ScrollReveal from '@/pages/home/components/ScrollReveal';

const benefits = [
  { icon: 'ri-money-cny-circle-line', title: '丰厚收益分成', desc: '订阅分成、打赏分成、广告分成多管齐下，让创作者的每一份努力都有回报。', tag: '多管道变现' },
  { icon: 'ri-fire-line', title: '海量流量扶持', desc: '首页推荐位、专题策划、榜单曝光，优质作品轻松触达千万漫迷。', tag: '千万级曝光' },
  { icon: 'ri-shield-check-line', title: '版权保驾护航', desc: '专业法务团队维权，原创内容版权得到充分保护，安心创作无后顾之忧。', tag: '专业维权' },
  { icon: 'ri-tools-line', title: '一站式创作工具', desc: '分镜模板、排版工具、云端协作，让创作流程更高效、更专业。', tag: '高效创作' },
];

const steps = [
  { step: '01', icon: 'ri-upload-cloud-2-line', title: '注册投稿', desc: '完成创作者认证，上传你的原创漫画作品。' },
  { step: '02', icon: 'ri-file-check-line', title: '审核签约', desc: '编辑团队快速审核，签约后即可开启创作之旅。' },
  { step: '03', icon: 'ri-rocket-line', title: '上架运营', desc: '作品上架天天漫画，获得流量与推广支持。' },
  { step: '04', icon: 'ri-wallet-3-line', title: '收益结算', desc: '按周期结算收益，透明清晰、及时到账。' },
];

export default function Creator() {
  return (
    <div className="min-h-screen bg-white pt-20 overflow-hidden">
      {/* ===== 漫画风 Hero ===== */}
      <section className="relative px-4 md:px-8 lg:px-16 xl:px-24 pt-16 md:pt-24 pb-14 md:pb-20">
        {/* 网点背景装饰 */}
        <div className="absolute top-0 right-0 w-[440px] h-[440px] bg-[radial-gradient(circle,rgba(255,107,138,0.10)_1.5px,transparent_1.5px)] [background-size:18px_18px] pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-[300px] h-[300px] bg-[radial-gradient(circle,rgba(26,26,26,0.05)_1.5px,transparent_1.5px)] [background-size:16px_16px] pointer-events-none" />

        {/* 速度线装饰 */}
        <div className="absolute top-12 left-1/2 -translate-x-1/2 hidden md:flex gap-2 pointer-events-none">
          {[0, 1, 2, 3, 4].map((i) => (
            <span
              key={i}
              className="w-px bg-pink-200/70"
              style={{ height: `${90 + i * 24}px`, transform: `rotate(${(i - 2) * 8}deg)` }}
            />
          ))}
        </div>

        <div className="relative max-w-5xl mx-auto text-center">
          <ScrollReveal>
            {/* 对话气泡式标签 */}
            <div className="flex justify-center mb-7">
              <div className="relative">
                <span className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-white border-2 border-gray-900 font-serif text-sm font-bold text-gray-900 shadow-[3px_3px_0_0_#ff9db8]">
                  <i className="ri-quill-pen-line text-pink-500" />
                  创作者平台
                </span>
                <div className="absolute -bottom-2 left-1/2 -translate-x-1/2 w-3 h-3 bg-white border-b-2 border-r-2 border-gray-900 rotate-45" />
              </div>
            </div>

            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight tracking-tight">
              让每一个好故事
              <span className="relative inline-block ml-3">
                被看见
                <span className="absolute -bottom-2 left-0 right-0 h-2 bg-pink-200/80 -rotate-1 rounded-full" />
              </span>
            </h1>

            <p className="mt-7 text-base md:text-lg text-gray-500 max-w-2xl mx-auto leading-relaxed">
              天天漫画创作者平台面向全球漫画创作者开放，无论你是独立漫画家还是团队，这里都能为你提供舞台。
            </p>
          </ScrollReveal>
        </div>
      </section>

      {/* ===== 创作者权益 ===== */}
      <section className="relative px-4 md:px-8 lg:px-16 xl:px-24 pb-16 md:pb-24">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal>
            <div className="flex items-center gap-4 justify-center mb-12 md:mb-16">
              <span className="h-px w-10 bg-gray-300" />
              <h2 className="font-serif text-2xl md:text-3xl font-bold text-gray-900">创作者专属权益</h2>
              <span className="h-px w-10 bg-gray-300" />
            </div>
          </ScrollReveal>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {benefits.map((b, i) => (
              <ScrollReveal key={b.title} delay={i * 80}>
                <div className="group relative h-full rounded-2xl border-2 border-gray-900 bg-white p-7 md:p-8 text-center shadow-[5px_5px_0_0_#ffe0e6] hover:shadow-[5px_5px_0_0_#ff9db8] hover:-translate-y-1.5 transition-all duration-300">
                  {/* 网点角标 */}
                  <div className="absolute top-3 right-3 w-14 h-14 bg-[radial-gradient(circle,rgba(255,107,138,0.14)_1.5px,transparent_1.5px)] [background-size:9px_9px] pointer-events-none" />
                  {/* 标签贴纸 */}
                  <span className="absolute top-3 left-3 inline-flex items-center px-2.5 py-1 rounded-full bg-amber-300/70 border border-gray-900 text-[10px] font-bold text-gray-900">
                    {b.tag}
                  </span>

                  <div className="relative">
                    <div className="w-16 h-16 mx-auto mb-5 rounded-2xl border-2 border-gray-900 bg-pink-50 flex items-center justify-center group-hover:rotate-6 transition-transform duration-300">
                      <i className={`${b.icon} text-2xl text-pink-500`} />
                    </div>
                    <h3 className="text-base font-bold text-gray-900 mb-2">{b.title}</h3>
                    <p className="text-sm text-gray-500 leading-relaxed">{b.desc}</p>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>

      {/* ===== 四步创作之旅 ===== */}
      <section className="relative px-4 md:px-8 lg:px-16 xl:px-24 pb-20 md:pb-28">
        {/* 网点背景 */}
        <div className="absolute top-10 right-0 w-[260px] h-[260px] bg-[radial-gradient(circle,rgba(255,107,138,0.08)_1.5px,transparent_1.5px)] [background-size:16px_16px] pointer-events-none" />

        <div className="max-w-6xl mx-auto relative">
          <ScrollReveal>
            <div className="flex items-center gap-4 justify-center mb-12 md:mb-16">
              <span className="h-px w-10 bg-gray-300" />
              <h2 className="font-serif text-2xl md:text-3xl font-bold text-gray-900">四步开启创作之旅</h2>
              <span className="h-px w-10 bg-gray-300" />
            </div>
          </ScrollReveal>

          <div className="relative">
            {/* 横向连接虚线 */}
            <div className="hidden lg:block absolute top-[42px] left-[12.5%] right-[12.5%] h-0.5 bg-[repeating-linear-gradient(to_right,rgba(255,107,138,0.4)_0_10px,transparent_10px_20px)]" />

            <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
              {steps.map((s, i) => (
                <ScrollReveal key={s.step} delay={i * 90}>
                  <div className="relative text-center lg:text-left">
                    {/* 数字块 */}
                    <div className="relative z-10 inline-flex items-center justify-center w-[84px] h-[84px] rounded-2xl border-2 border-gray-900 bg-white shadow-[4px_4px_0_0_#ff9db8]">
                      <span className="font-serif text-3xl font-bold text-pink-500">{s.step}</span>
                      <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-gray-900 text-white flex items-center justify-center">
                        <i className={`${s.icon} text-xs`} />
                      </span>
                    </div>
                    <h3 className="text-base font-bold text-gray-900 mt-4 mb-2">{s.title}</h3>
                    <p className="text-sm text-gray-500 leading-relaxed">{s.desc}</p>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}